import React, { createContext, useContext, useState } from 'react';
import en from './en.json';
import ro from './ro.json';

const translations = { en, ro };

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('biblika-lang');
    return saved && translations[saved] ? saved : 'ro';
  });

  const t = (key, params) => {
    let str = translations[lang][key] || translations.en[key] || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        str = str.replace(`{${k}}`, v);
      });
    }
    return str;
  };

  const switchLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem('biblika-lang', newLang);
  };

  return (
    <LanguageContext.Provider value={{ lang, t, switchLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
